export type ObjectBookingStatus =
  | 'payment_pending_confirmation'
  | 'confirmed'
  | 'refund_pending'
  | 'cancelled'
  | 'refunded'
  | 'refund_rejected'

export type ObjectBookingsHistoryTab = 'active' | 'archive'

export const objectBookingsHistoryTabs: ObjectBookingsHistoryTab[] = [
  'active',
  'archive',
]

export interface ObjectBooking {
  id: string
  status: ObjectBookingStatus
  statusLabel: string
  title: string
  address: string
  startDate: string
  endDate: string
  nightsCount: number
  guestsCount: number
}
